import RestApi from './../../api/rest-api-client'
const srvcEndpoint = '/push_device_registry'
export default {
  search: async (req, opts) => RestApi.request('GET', srvcEndpoint, req, opts),
  get: async (id, req, opts) => RestApi.request('GET', srvcEndpoint, id, req, opts),

  // Upsert this browser profile. Deliberately carries NO user_id — the server
  // takes identity from the verified Firebase ID token only, so a device can
  // never be bound to an impersonated agent.
  register: async (data, opts) =>
    RestApi.request('POST', srvcEndpoint, data, {
      ...(opts || {}),
      endpoint: `${srvcEndpoint}/register`,
    }),

  // Release on sign-out. Clears the token but does NOT suppress — the same
  // person signing back in should find notifications still on.
  revoke: async (deviceUid, opts) => RestApi.request('DELETE', srvcEndpoint, deviceUid, opts),

  // Switch a device off and KEEP it off. Works for any of the caller's own
  // devices, including remote ones: the server refuses to re-arm a suppressed
  // device when it next checks in, so it cannot silently come back.
  // Record the "did you actually see it?" answer. The only positive proof that
  // notifications display on this device — OS-level suppression is otherwise
  // undetectable from the browser.
  verify: async (deviceUid, verified, opts) =>
    RestApi.request(
      'POST',
      srvcEndpoint,
      { verified: !!verified },
      {
        ...(opts || {}),
        endpoint: `${srvcEndpoint}/${deviceUid}/verify`,
      }
    ),

  suppress: async (deviceUid, opts) =>
    RestApi.request(
      'POST',
      srvcEndpoint,
      {},
      {
        ...(opts || {}),
        endpoint: `${srvcEndpoint}/${deviceUid}/suppress`,
      }
    ),
}
